import { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { Url } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import { getDeviationFreeDownload, getDeviationPremiumDownload } from './permissions';
/**
 * This actually covers free and tier-subscription-gated downloads
 */ export function useFreeDownloadAction(deviation, isOwner) {
    const { isLoggedIn  } = useContext(SessionContext);
    const { restrictToLoggedIn  } = useRestrictToLoggedIn();
    const { isDownloadable  } = useDeviationAttributes(deviation, isOwner);
    if (!isDownloadable) {
        return {
            hasAction: false
        };
    }
    if (!isLoggedIn) {
        return {
            onClick: restrictToLoggedIn(ReferralType.ACTION_BAR),
            hasAction: true
        };
    }
    const { download , permission  } = getDeviationFreeDownload(deviation);
    if (permission === 'needs_subscription' || permission === 'blocked_by_subscription') {
        return {
            onClick: ()=>alert('You need to subscribe to this deviant to download this content.'),
            hasAction: true
        };
    }
    return {
        href: download === null || download === void 0 ? void 0 : download.url,
        hasAction: true
    };
}
export function usePremiumDownloadAction(deviation, isOwner) {
    var _deviation_pcp;
    const { isLoggedIn  } = useContext(SessionContext);
    const { isPurchasable , isDownloadable  } = useDeviationAttributes(deviation, isOwner);
    const { restrictToLoggedIn  } = useRestrictToLoggedIn();
    if (!isDownloadable) {
        return {
            hasAction: false
        };
    }
    if (!isLoggedIn) {
        return {
            onClick: restrictToLoggedIn(ReferralType.ACTION_BAR),
            hasAction: true
        };
    }
    if (!isPurchasable) {
        return {
            hasAction: false
        };
    }
    const checkoutUrl = ((_deviation_pcp = deviation.pcp) === null || _deviation_pcp === void 0 ? void 0 : _deviation_pcp.subproductId) ? Url.checkoutLink(deviation.pcp.subproductId) : undefined;
    const { download , permission  } = getDeviationPremiumDownload(deviation, isOwner);
    return {
        href: permission === 'downloadable' ? download === null || download === void 0 ? void 0 : download.url : checkoutUrl,
        hasAction: true
    };
}
